<template>
  <div id="article-gallery-comp">
    <div class="sc-main" v-if="items">
      <swiper
        :style="{
          '--swiper-navigation-color': '#fff',
          '--swiper-pagination-color': '#fff',
        }"
        :spaceBetween="10"
        :navigation="!isMobile ? true : false"
        :pagination="{
          dynamicBullets: true,
          dynamicMainBullets: 5,
        }"
        :thumbs="{ swiper: thumbsSwiper }"
        :modules="modules"
        class="mySwiper"
      >
        <swiper-slide v-for="item in items" :key="item.id">
          <img :src="item.path" />
        </swiper-slide>
      </swiper>
      <swiper
        @swiper="setThumbsSwiper"
        :spaceBetween="10"
        :slidesPerView="4"
        :freeMode="true"
        :watchSlidesProgress="true"
        :modules="modules"
        class="mySwiperPreview"
        v-if="!isMobile"
      >
        <swiper-slide v-for="item in items" :key="item.id">
          <div
            class="slide-img"
            :style="{ 'background-image': 'url(' + item.path + ')' }"
          ></div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script>
import mobileChecker from '@/mixins/mobileChecker';

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';

import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';
// import required modules
import { FreeMode, Navigation, Pagination, Thumbs } from 'swiper';

export default {
  mixins: [mobileChecker],
  props: ['items'],
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      thumbsSwiper: null,
    };
  },
  methods: {
    setThumbsSwiper(swiper) {
      this.thumbsSwiper = swiper;
    },
  },
  setup() {
    return {
      modules: [FreeMode, Pagination, Navigation, Thumbs],
    };
  },
};
</script>
<style lang="scss" scoped>
@import 'swiper/css/pagination';

#article-gallery-comp {
  width: 50%;

  @media (max-width: 767px) {
    width: 100%;
    margin-bottom: 2rem;
  }

  .sc-main {
    width: 100%;
  }

  .mySwiper {
    .swiper-button-next,
    .swiper-button-prev {
      color: $color-primary;
    }
    .swiper-slide {
      height: 450px;
      position: relative;

      @media (max-width: 767px) {
        height: 250px;
      }

      img {
        height: auto;
        width: auto;
        max-width: 100%;
        max-height: 100%;
        margin: 0 auto;
        -o-object-fit: contain;
        object-fit: contain;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .swiper-pagination {
      .swiper-pagination-bullet {
        height: 150px;
      }
    }
    .swiper-pagination-bullet-active {
      background-color: #000 !important;
    }
  }

  .mySwiperPreview {
    width: 70%;
    margin-top: 2rem;
    .swiper-slide {
      aspect-ratio: 1 / 1;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      &.swiper-slide-thumb-active {
        border: 4px solid $color-secondary;
      }

      .slide-img {
        height: 90%;
        width: 90%;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        border: 1.5px solid $color-quaternary;
        border-radius: 50%;
        cursor: pointer;
      }
    }
  }
}
</style>
